import RichTextWithIconLinkAndTitleBlock from './RichTextWithIconLinkAndTitleBlock';

export default RichTextWithIconLinkAndTitleBlock;
